import { MessageCircle } from "lucide-react";

const WhatsAppWidget = () => (
  <a
    href="https://wa.me/916360372623"
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-lg hover:bg-[#20BD5A] transition-colors hover:scale-110 duration-200"
    data-testid="whatsapp-widget"
    aria-label="Chat on WhatsApp"
  >
    <MessageCircle size={28} fill="white" />
  </a>
);

export default WhatsAppWidget;
